module.exports = __webpack_public_path__ + "img/bottom (2).2391b827.png";